import { useEffect, useRef, useState } from "react";
import { JoDetailType, JoStatusType } from "../../../db/model";
import { toast } from "react-toastify";
import imageCompression from "browser-image-compression";
import CachedIcon from "@mui/icons-material/Cached";
import AddAPhotoIcon from "@mui/icons-material/AddAPhoto";
import ImageIcon from "@mui/icons-material/Image";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  DeleteJobworkImageAPI,
  GetJobworkStatusImageAPI,
  UploadJobworkImageAPI,
} from "../../../db/apiCalls";
import ErrorBoundary from "../../../ErrorBoundary";

function StatusUpdateDetailCard({
  joStatusList,
  joDetail,
  customImageModal,
  getJobworkDetailByJoNo,
  customConfirm,
}: {
  joStatusList: JoStatusType[];
  joDetail: JoDetailType;
  customImageModal: (
    imageString: string,
    remarksString: string,
    joNo: string,
    status: string
  ) => void;
  getJobworkDetailByJoNo: () => void;
  customConfirm: (
    msg: string,
    onConfirmCallback: () => void,
    onCancelCallback?: () => void,
    confirmTextfn?: "Confirm" | "Cancel" | "Delete" | "Alert"
  ) => void;
}) {
  function formatDate(someDate: Date) {
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sept",
      "Oct",
      "Nov",
      "Dec",
    ];
    const yyyy = new Date(someDate).getFullYear();
    // let mmNo = new Date(someDate).getMonth() + 1; // Months start at 0!
    let mmNo = new Date(someDate).getMonth(); // Months start at 0!
    let ddNo = new Date(someDate).getDate();

    let dd = ddNo.toString();
    // let mm = mmNo.toString();

    if (ddNo < 10) dd = "0" + ddNo.toString();
    // if (mmNo < 10) mm = "0" + mmNo.toString();

    const formattedDate = dd + "-" + months[mmNo] + "-" + yyyy;

    return formattedDate;
  }

  function formatDateTime(someDate: Date) {
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sept",
      "Oct",
      "Nov",
      "Dec",
    ];

    const dateObj = new Date(someDate);
    const yyyy = dateObj.getFullYear();
    const mmNo = dateObj.getMonth(); // Months start at 0!
    const ddNo = dateObj.getDate();
    const hhNo = dateObj.getHours();
    const minNo = dateObj.getMinutes();

    const dd = ddNo < 10 ? "0" + ddNo : ddNo.toString();
    const hh = hhNo < 10 ? "0" + hhNo : hhNo.toString();
    const min = minNo < 10 ? "0" + minNo : minNo.toString();

    const formattedDateTime = `${dd}-${months[mmNo]}-${yyyy} ${hh}:${min}`;

    return formattedDateTime;
  }

  const imageCaptureInput = useRef<HTMLInputElement>(null);

  // image upload

  const [file, setFile] = useState<any>();
  const [imageLoading, setImageLoading] = useState(false);
  const [imagePreview, setImagePreview] = useState<any>(null);
  const [base64, setBase64] = useState<string>();

  const allowedImageType = ["image/jpeg", "image/png"];

  const fileInputRef = useRef<HTMLInputElement>(null);

  const uploadImageButtonRef = useRef<HTMLButtonElement>(null);
  const viewImageButton = useRef<HTMLButtonElement>(null);
  const deleteImageButton = useRef<HTMLButtonElement>(null);

  const remarksRef = useRef<HTMLTextAreaElement>(null);

  const compressionOptions = {
    maxSizeMB: 1,
    maxWidthOrHeight: 1920,
    useWebWorker: true,
  };

  useEffect(() => {
    if (file) {
      if (!allowedImageType.includes(file.type)) {
        removeSelectedImage();
        setImageLoading(false);
        toast.error("Only image type .jpg, .jpeg and.png are allowed!");
        return;
      }
      // if (file.size > 1024 * 1024 * 1) {
      //   removeSelectedImage();
      //   setImageLoading(false);
      //   toast.error("Image size can not be above 2 MB!");
      // }
      else {
        const reader = new FileReader();
        reader.onload = (readerEvt: any) => {
          let binaryString = readerEvt.target.result;
          setBase64(btoa(binaryString));
        };
        reader.readAsBinaryString(file);
      }
    }

    // eslint-disable-next-line
  }, [file]);

  const photoUpload = async (e: any) => {
    e.preventDefault();
    setImageLoading(true);

    const reader = new FileReader();
    let file = await e.target.files[0];

    if (file && file.size > 1024 * 1024 * 1) {
      //1 MB
      file = await imageCompression(file, compressionOptions);
    }

    if (reader !== undefined && file !== undefined) {
      reader.onloadend = () => {
        setFile(file);
        setImagePreview(reader.result);

        // console.log("image preview", reader.result);
        // console.log("file", file);
      };
      reader.readAsDataURL(file);
    }

    setImageLoading(false);
  };

  const removeSelectedImage = () => {
    setFile(null);
    setImagePreview(null);
    setImageLoading(false);
    setBase64("");
  };

  const formatImageSize = (size: number) => {
    const sizeInKb = size / 1024;

    if (sizeInKb > 1024) {
      return `${(sizeInKb / 1024).toFixed(2)} mb`;
    } else {
      return `${sizeInKb.toFixed(2)} kb`;
    }
  };

  const [selectedStatus, setSelectedStatus] = useState("");

  // useEffect(() => {
  fileInputRef.current?.addEventListener("cancel", () => {
    removeSelectedImage();
    setImageLoading(false);
  });
  // }, []);

  // useEffect(() => {
  //   if (base64) console.log("base64", base64);
  // }, [base64]);

  async function statusUpdate() {
    uploadImageButtonRef.current!.disabled = true;
    uploadImageButtonRef.current!.innerText = "Saving...";

    const remarks = remarksRef.current?.value;

    if (!selectedStatus) {
      toast.warning("Please select a status");
    } else if (!base64) {
      toast.warning("Please capture an image first!");
    } else if (!remarks) {
      toast.warning("Remarks is required!");
    } else {
      const result = await UploadJobworkImageAPI(
        joDetail.orderNo,
        joDetail.osNo,
        selectedStatus,
        base64,
        remarks
      );

      const parsedResponse = result
        ? JSON.parse(result)
        : {
            statusCode: 0,
            message: "Please check your internet connection!",
            success: false,
          };

      if (parsedResponse.success) {
        toast.success(parsedResponse.message);
        removeSelectedImage();
        setSelectedStatus("");
        getJobworkDetailByJoNo();
      } else {
        toast.error(parsedResponse.message);
      }
    }

    uploadImageButtonRef.current!.disabled = false;
    uploadImageButtonRef.current!.innerText = "Save";
  }

  async function showImageInModal(
    joNo: string,
    oSno: number,
    statusCode: string
  ) {
    const result = await GetJobworkStatusImageAPI(joNo, oSno, statusCode);

    const parsedResponse = result
      ? JSON.parse(result)
      : {
          statusCode: 0,
          message: "Please check your internet connection.",
          success: false,
          image: "",
          remark: [],
        };

    if (parsedResponse.success) {
      customImageModal(
        parsedResponse.image,
        parsedResponse.remark[0].remarks,
        joDetail.orderNo,
        joStatusList.find((status) => status.statusCode === selectedStatus)
          ?.statusName || "Status"
      );
    } else {
      toast.error(parsedResponse.message);
    }
  }

  async function deleteJoStatusImage() {
    const result = await DeleteJobworkImageAPI(
      joDetail.orderNo,
      joDetail.osNo,
      selectedStatus
    );

    const parsedResponse = result
      ? JSON.parse(result)
      : {
          statusCode: 0,
          message: "Please check your internet connection!",
          success: false,
        };

    if (parsedResponse.success) {
      toast.success(parsedResponse.message);
      getJobworkDetailByJoNo();
    } else {
      toast.error(parsedResponse.message);
    }
  }

  return (
    <ErrorBoundary>
      <div
        className={`block rounded-lg ${
          joDetail.isUpdatedToday ? "bg-yellow-100" : "bg-white"
        } pt-4 px-6 pb-2 shadow-slate-600/55 shadow-md dark:bg-neutral-700`}
      >
        <div className="flex justify-between">
          <h5 className="mb-2 text-sm font-medium leading-tight text-neutral-800 dark:text-neutral-50">
            JO No: <span className="font-bold">{joDetail.orderNo}</span>
          </h5>
          <h5 className="mb-2 text-sm font-medium leading-tight text-neutral-800 dark:text-neutral-50">
            {/* Order Date:{" "} */}
            <span className="font-bold">
              {formatDate(new Date(joDetail.orderDate))}
            </span>
          </h5>
        </div>

        {/* <div className="flex justify-between"> */}
        <h5 className="mb-2 text-sm font-medium leading-tight text-neutral-800 dark:text-neutral-50">
          Party Name: <span className="font-bold">{joDetail.partyName}</span>
        </h5>

        {/* <h5 className="mb-2 text-sm font-medium leading-tight text-neutral-800 dark:text-neutral-50">
          {joDetail.osNo}
        </h5>
      </div> */}

        <h5 className="mb-2 text-sm font-medium leading-tight text-neutral-800 dark:text-neutral-50">
          Item Name: <span className="font-bold">{joDetail.itemName}</span>
        </h5>

        <h5 className="mb-2 text-sm font-medium leading-tight text-neutral-800 dark:text-neutral-50">
          Shade: <span className="font-bold">{joDetail.shade}</span>
        </h5>

        <h5 className="mb-2 text-sm font-medium leading-tight text-neutral-800 dark:text-neutral-50">
          Type: <span className="font-bold">{joDetail.orderForm}</span>
        </h5>

        <h5 className="mb-2 text-sm font-medium leading-tight text-neutral-800 dark:text-neutral-50">
          Packed Quantity:{" "}
          <span className="font-bold">{joDetail.packedQuantity}</span>
        </h5>

        <div className="flex flex-col lg:flex-row gap-y-1 gap-x-4 my-2">
          <select
            name="status"
            id="status"
            value={selectedStatus}
            onChange={(e) => setSelectedStatus(e.target.value)}
            className="block w-full md:w-auto rounded-md border-0 py-1.5 px-2 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 text-sm sm:leading-6 my-2"
          >
            <option value="">Select Status</option>
            {joStatusList.map((status, index) => {
              if (status.active === "Y") {
                return (
                  <option value={status.statusCode} key={index}>
                    {status.statusName}
                  </option>
                );
              } else {
                return null;
              }
            })}
          </select>

          {selectedStatus &&
            ((selectedStatus === "SC001" && joDetail.loadingImage === "Y") ||
              (selectedStatus === "SC002" && joDetail.unLoadingImage === "Y") ||
              (selectedStatus === "SC003" &&
                joDetail.dyedOrPrintedImage === "Y") ||
              (selectedStatus === "SC004" &&
                joDetail.checkedOrFinishedImage === "Y") ||
              (selectedStatus === "SC005" &&
                joDetail.dispatchedImage === "Y")) && (
              <span className="flex flex-col md:flex-row gap-x-1 my-auto text-sm">
                <span className="my-auto text-nowrap">
                  Image already uploaded.{" "}
                </span>
                <div className="flex gap-x-1">
                  <button
                    ref={viewImageButton}
                    className="bg-blue-500 hover:bg-blue-600 text-white px-2 py-1 rounded-lg disabled:bg-gray-600 font-semibold"
                    onClick={async () => {
                      viewImageButton.current!.disabled = true;
                      await showImageInModal(
                        joDetail.orderNo,
                        joDetail.osNo,
                        selectedStatus
                      );
                      viewImageButton.current!.disabled = false;
                    }}
                  >
                    <span className="flex flex-row gap-x-1">
                      <span className="my-auto flex justify-center">
                        <ImageIcon fontSize="small" />
                      </span>
                      <span className="my-auto flex justify-center">View</span>
                    </span>
                  </button>

                  <span className="my-auto font-semibold">/</span>

                  <button
                    ref={deleteImageButton}
                    className="bg-red-500 hover:bg-red-600 text-white px-2 py-1 rounded-lg disabled:bg-gray-600 font-semibold"
                    onClick={async () => {
                      deleteImageButton.current!.disabled = true;
                      // await deleteJoStatusImage();
                      await customConfirm(
                        `Do you want to delete the image in JO No. ${
                          joDetail.orderNo
                        } with status ${
                          joStatusList.find(
                            (status) => status.statusCode === selectedStatus
                          )?.statusName
                        }`,
                        async () => await deleteJoStatusImage(),
                        () => {},
                        "Delete"
                      );
                      deleteImageButton.current!.disabled = false;
                    }}
                  >
                    <span className="flex flex-row gap-x-1">
                      <span className="my-auto flex justify-center">
                        <DeleteIcon fontSize="small" />
                      </span>
                      <span className="my-auto flex justify-center">
                        Delete
                      </span>
                    </span>
                  </button>
                </div>
              </span>
            )}
        </div>

        {joDetail.remarks.length > 0 && (
          <>
            <h1 className="font-bold">Remarks List -</h1>

            <div className="max-h-36 overflow-y-auto overflow-x-auto mb-2">
              <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
                <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                  <tr>
                    <th scope="col" className="px-4 py-2">
                      Status
                    </th>
                    <th scope="col" className="px-4 py-2">
                      Date
                    </th>
                    <th scope="col" className="px-4 py-2">
                      Remarks
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {joDetail.remarks.map((remark, index) => (
                    <tr
                      className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 border-gray-200"
                      key={index}
                    >
                      <td className="px-4 py-3 text-nowrap">
                        {
                          joStatusList.find(
                            (status) => status.statusCode === remark.statusCode
                          )?.statusName
                        }
                      </td>
                      <td className="px-4 py-3 text-nowrap">
                        {formatDateTime(new Date(remark.systemDateTime))}
                      </td>
                      <td className="px-4 py-3">
                        <p className="min-w-24">{remark.remarks}</p>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </>
        )}

        <div>
          <input
            type="file"
            accept="image/png, image/jpeg"
            capture={"environment"}
            ref={imageCaptureInput}
            onChange={photoUpload}
            hidden
          />

          {imagePreview ? (
            <>
              <section>
                <div className="text-ellipsis overflow-clip">
                  <label>Name : </label>
                  <span className="text-ellipsis">{file?.name}</span>
                </div>

                <div>
                  <label>Size : </label>
                  <span>
                    {formatImageSize(file?.size ? parseInt(file?.size) : 0)}
                  </span>
                </div>
              </section>
              <div>
                <button
                  type="button"
                  onClick={removeSelectedImage}
                  className="bg-gray-200 border rounded px-2 py-1.5 mt-2 hover:bg-gray-300"
                >
                  Remove
                </button>
              </div>
            </>
          ) : (
            <button
              className="bg-blue-300 hover:bg-blue-400 rounded-md p-2 w-full md:w-auto text-sm"
              onClick={() => {
                setImageLoading(true);
                imageCaptureInput.current?.click();
              }}
            >
              <span className="flex flex-row gap-x-1 justify-center">
                <span className="my-auto flex justify-center">
                  <AddAPhotoIcon className="mx-auto" />
                </span>
                <span className="my-auto flex justify-center">
                  Capture Image
                </span>
              </span>
            </button>
          )}

          {!imagePreview ? (
            <div className="max-w-fit text-center mb-3">
              {imageLoading && (
                <CachedIcon className="animate-spin" fontSize="large" />
              )}
              <h6 className="font-semibold">
                {imageLoading && "Loading Selected Image..."}
              </h6>
            </div>
          ) : (
            <div className="w-full mb-3 object-contain">
              <h3>Selected Image :</h3>
              <img
                src={imagePreview}
                alt="selected-img"
                className="object-contain max-h-[50vh] md:max-h-[40vh] mx-auto"
              />
            </div>
          )}
          {imagePreview && base64 && (
            <>
              <div className="my-2">
                <textarea
                  name="remarks"
                  ref={remarksRef}
                  className="block w-full rounded-md border-0 py-1.5 px-2 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                  placeholder="Remarks"
                  aria-describedby="basic-addon1"
                />
              </div>

              <button
                type="button"
                onClick={statusUpdate}
                ref={uploadImageButtonRef}
                className="inline-block rounded bg-blue-500 px-6 pb-2 pt-2.5 text-xs font-medium leading-normal text-white w-full md:w-auto shadow-slate-600 hover:shadow-slate-600 shadow-md hover:shadow-lg hover:bg-blue-600 disabled:bg-slate-600"
              >
                Save
              </button>
            </>
          )}
        </div>
      </div>
    </ErrorBoundary>
  );
}

export default StatusUpdateDetailCard;
